import type { GeoBoundingBox, NonGeoBoundingBox } from '@deck.gl/geo-layers';

type TileBoundingBox = GeoBoundingBox | NonGeoBoundingBox;

function isGeoBoundingBox(bbox: TileBoundingBox): bbox is GeoBoundingBox {
  return (
    'west' in bbox &&
    Number.isFinite(bbox.west) &&
    Number.isFinite(bbox.north) &&
    Number.isFinite(bbox.east) &&
    Number.isFinite(bbox.south)
  );
}

/** Geospatial tile layers in this app always use WGS84 bbox. */
export function geoBbox(bbox: TileBoundingBox): GeoBoundingBox {
  if (!isGeoBoundingBox(bbox)) {
    throw new Error('Expected WGS84 tile bbox (west/north/east/south)');
  }
  return bbox;
}
